import { render, staticRenderFns } from "./minQuantity.vue?vue&type=template&id=52e98014"
import script from "./minQuantity.vue?vue&type=script&lang=js"
export * from "./minQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports